import { render, staticRenderFns } from "./DesignTrackerView.vue?vue&type=template&id=652fedc4&"
import script from "./DesignTrackerView.vue?vue&type=script&lang=js&"
export * from "./DesignTrackerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports